var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import * as Bluebird from "bluebird";
var debug = require("debug");
import h from "../helper/helper";
import Progress from "../asset/Progress";
import blobCache from "../asset/blobCache";
import socketService from "./socket.service";
import BlobDownloader from "./blobDownloader.service";
var initService = require("services/initService");
import Queue from "../asset/Queue";
var keyStore = require("crypto/keyStore");
var knownBlobURLs = {};
var downloadBlobQueue = new Queue(5);
downloadBlobQueue.start();
var debugName = "whispeer:blobService";
var blobServiceDebug = debug(debugName);
var time = function (name) {
    if (debug.enabled(debugName)) {
        // eslint-disable-next-line no-console
        console.time(name);
    }
};
var timeEnd = function (name) {
    if (debug.enabled(debugName)) {
        // eslint-disable-next-line no-console
        console.timeEnd(name);
    }
};
export var unpath = function (path) {
    var index = Math.max(path.lastIndexOf("/"), path.lastIndexOf("\\")) + 1;
    return {
        directory: path.substr(0, index),
        name: path.substr(index)
    };
};
var MyBlob = /** @class */ (function () {
    function MyBlob(blobData, blobID, options) {
        this.blobData = blobData;
        options = options || {};
        if (blobID) {
            this.blobID = blobID;
            this.uploaded = true;
        }
        else {
            this.uploaded = false;
        }
        this.meta = options.meta || {};
        this.key = this.meta._key || this.meta.key;
        this.decrypted = options.decrypted || !this.key;
        this.uploadProgress = new Progress({ total: this.getSize() });
        this.encryptProgress = new Progress({ total: this.getSize() });
        this.decryptProgress = new Progress({ total: this.getSize() });
    }
    MyBlob.prototype.isDecrypted = function () {
        return this.decrypted;
    };
    MyBlob.prototype.isUploaded = function () {
        return this.uploaded;
    };
    MyBlob.prototype.getSize = function () {
        return this.blobData.size;
    };
    MyBlob.prototype.getMeta = function () {
        return this.meta;
    };
    MyBlob.prototype.getArrayBuffer = function () {
        var _this = this;
        if (this.blobData.originalUrl) {
            var _a = unpath(this.blobData.originalUrl), directory = _a.directory, name_1 = _a.name;
            return blobCache.readFileAsArrayBuffer(directory, name_1);
        }
        return new Bluebird(function (resolve) {
            var reader = new FileReader();
            if (reader.addEventListener) {
                reader.addEventListener("loadend", resolve);
            }
            else {
                reader.onloadend = resolve;
            }
            reader.readAsArrayBuffer(_this.blobData);
        }).then(function (event) {
            var target = event.currentTarget || event.target;
            return target.result;
        });
    };
    MyBlob.prototype.encryptAndUpload = function (key) {
        var _this = this;
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var blobKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.encrypt()];
                    case 1:
                        blobKey = _a.sent();
                        return [4 /*yield*/, keyStore.sym.symEncryptKey(blobKey, key)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.upload()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, blobKey];
                }
            });
        }); });
    };
    MyBlob.prototype.encrypt = function () {
        var _this = this;
        return Bluebird.resolve().then(function () {
            if (_this.uploaded || !_this.decrypted) {
                throw new Error("trying to encrypt an already encrypted or public blob. add a key decryptor if you want to give users access");
            }
            return Bluebird.all([
                keyStore.sym.generateKey(null, "blob key"),
                _this.getArrayBuffer()
            ]);
        }).spread(function (key, buf) {
            _this.key = key;
            time("blobencrypt" + (_this.blobID || _this.preReservedID));
            return keyStore.sym.encryptArrayBuffer(buf, _this.key, function (progress) {
                _this.encryptProgress.progress(_this.getSize() * progress);
            });
        }).then(function (encryptedData) {
            _this.encryptProgress.progress(_this.getSize());
            timeEnd("blobencrypt" + (_this.blobID || _this.preReservedID));
            blobServiceDebug(encryptedData.byteLength);
            _this.decrypted = false;
            _this.blobData = new Blob([encryptedData], { type: _this.blobData.type });
            return _this.key;
        });
    };
    MyBlob.prototype.decrypt = function (originalSize) {
        var _this = this;
        if (this.decrypted) {
            return Bluebird.resolve();
        }
        return Bluebird.try(function () {
            return _this.getArrayBuffer();
        }).then(function (encryptedData) {
            time("blobdecrypt" + _this.blobID);
            return keyStore.sym.decryptArrayBuffer(encryptedData, _this.key, function (progress) {
                _this.decryptProgress.progress(_this.getSize() * progress);
            });
        }).then(function (decryptedData) {
            _this.decryptProgress.progress(_this.getSize());
            timeEnd("blobdecrypt" + _this.blobID);
            var unpaddedData = originalSize > 0 ? decryptedData.slice(0, originalSize) : decryptedData;
            _this.decrypted = true;
            _this.blobData = new Blob([unpaddedData], { type: _this.blobData.type });
            return blobCache.store(_this).catch(function (e) {
                console.log("Could not store blob", e);
                return _this.toURL();
            });
        });
    };
    MyBlob.prototype.toURL = function () {
        var _this = this;
        return Bluebird.try(function () {
            if (_this.blobData.localURL) {
                return _this.blobData.localURL;
            }
            if (typeof window.URL !== "undefined") {
                return window.URL.createObjectURL(_this.blobData);
            }
            if (typeof webkitURL !== "undefined") {
                return window.webkitURL.createObjectURL(_this.blobData);
            }
            return Bluebird.fromCallback(function (cb) {
                h.blobToDataURI(_this.blobData, cb);
            });
        }).catch(function () {
            return "";
        });
    };
    MyBlob.prototype.upload = function () {
        var _this = this;
        return Bluebird.try(function () {
            if (_this.uploaded) {
                return _this.blobID;
            }
            return _this.reserveID();
        }).then(function (blobid) {
            return socketService.uploadBlob(_this.blobData, blobid, _this.uploadProgress);
        }).then(function () {
            _this.uploaded = true;
            return _this.blobID;
        });
    };
    MyBlob.prototype.getBlobID = function () {
        return this.blobID;
    };
    MyBlob.prototype.getBlobData = function () {
        return this.blobData;
    };
    MyBlob.prototype.reserveID = function () {
        var _this = this;
        return Bluebird.try(function () {
            var meta = _this.meta;
            meta._key = _this.key;
            meta.one = 1;
            if (_this.preReservedID) {
                return socketService.definitlyEmit("blob.fullyReserveID", {
                    blobid: _this.preReservedID,
                    meta: meta
                });
            }
            return socketService.definitlyEmit("blob.reserveBlobID", {
                meta: meta
            });
        }).then(function (data) {
            if (data.blobid) {
                _this.blobID = data.blobid;
                return _this.blobID;
            }
        });
    };
    MyBlob.prototype.preReserveID = function () {
        var _this = this;
        return Bluebird.try(function () {
            return socketService.emit("blob.preReserveID", {});
        }).then(function (data) {
            if (data.blobid) {
                _this.preReservedID = data.blobid;
                return data.blobid;
            }
            throw new Error("got no blobid");
        });
    };
    MyBlob.prototype.getHash = function () {
        return this.getArrayBuffer().then(function (buf) {
            return keyStore.hash.hashArrayBuffer(buf);
        });
    };
    return MyBlob;
}());
var loadBlob = function (blobID, type, progress, size) {
    var decryptProgressStub = new Progress({ total: size });
    var downloadProgress = new Progress({ total: size });
    progress.addDepend(downloadProgress);
    progress.addDepend(decryptProgressStub);
    return downloadBlobQueue.enqueue(1, function () { return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
        var data, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initService.awaitLoading()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, new BlobDownloader(socketService, blobID, type, downloadProgress).download()];
                case 2:
                    data = _a.sent();
                    blob = new MyBlob(data.blob, blobID, { meta: data.meta });
                    if (blob.isDecrypted()) {
                        return [2 /*return*/, blobCache.store(blob).catch(function () { return blob.toURL(); })];
                    }
                    downloadProgress.progress(downloadProgress.getTotal());
                    progress.removeDepend(decryptProgressStub);
                    progress.addDepend(blob.decryptProgress);
                    return [2 /*return*/, blob.decrypt(size)];
            }
        });
    }); }); });
};
var getBlob = function (blobID, type, downloadProgress, estimatedSize) {
    if (!knownBlobURLs[blobID]) {
        knownBlobURLs[blobID] = loadBlob(blobID, type, downloadProgress, estimatedSize);
    }
    return knownBlobURLs[blobID];
};
var blobService = {
    createBlob: function (blob) {
        return new MyBlob(blob);
    },
    isBlobLoaded: function (blobID) {
        return blobCache.isLoaded(blobID);
    },
    getBlobUrl: function (blobID, type, estimatedSize, progress) {
        if (progress === void 0) { progress = new Progress(); }
        return blobCache.getBlobUrl(blobID).catch(function () {
            return getBlob(blobID, type, progress, estimatedSize);
        });
    },
};
export default blobService;



//////////////////
// WEBPACK FOOTER
// ./js/services/blobService.ts
// module id = null
// module chunks = 